import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  type CreateValuationRequestPayload,
  type ValuationRequestResponse
} from '../models/valuation-request.model';

@Injectable({ providedIn: 'root' })
export class ValuationRequestService {
  private readonly baseUrl = environment.baseUrl;

  constructor(private readonly http: HttpClient) {}

  create(payload: CreateValuationRequestPayload): Observable<ValuationRequestResponse> {
    return this.http.post<ValuationRequestResponse>(`${this.baseUrl}/ValuationRequests/Create`, payload);
  }
}
